import { configureStore, combineReducers } from '@reduxjs/toolkit'
import adaptabilityReducer from './features/adaptability/adaptabilitySlice'
import dataReducer from './features/data/dataSlice'
import expertiseReducer from './features/expertise/expertiseSlice'
import costReducer from './features/cost/costSlice'

const combinedReducer = combineReducers({
    adaptability: adaptabilityReducer,
    data: dataReducer,
    expertise: expertiseReducer,
    cost: costReducer

})

const rootReducer = (state, action) => {
    if (action.type === 'adaptability/restart') {
      state = undefined;
    }
    return combinedReducer(state, action);
  };

export default configureStore({
    reducer:rootReducer
})